// Contactus.js
import React, { useState } from "react";
import "../Contactus/Contactus.css";
import Location from "../Location/Location";
import Poster from "../Poster/Poster";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";

const Contactus = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    option: "",
    concern: "",
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    email: "",
    mobile: "",
    option: "",
    concern: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = (name, value) => {
    let errors = { ...formErrors };

    switch (name) {
      case "name":
        errors.name = /^[A-Za-z\s]+$/.test(value)
          ? ""
          : "Name should contain only alphabets.";
        break;
      case "email":
        errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ""
          : "Invalid email address.";
        break;
      case "mobile":
        errors.mobile = /^\d{10}$/.test(value)
          ? ""
          : "Mobile number should be 10 digits.";
        break;
      case "option":
        errors.option = value ? "" : "Please select an option.";
        break;
      case "concern":
        errors.concern =
          value.length >= 15
            ? ""
            : "Concern should be at least 15 characters long.";
        break;
      default:
        break;
    }

    setFormErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validate(name, value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const hasErrors =
      Object.values(formErrors).some((error) => error !== "") ||
      Object.values(formData).some((value) => value === "");

    if (hasErrors) {
      Swal.fire("Error", "Please fix the errors in the form.", "error");
      return;
    }

    setIsSubmitting(true);

    emailjs
      .send(
        "service_rj024nf",
        "template_ay4kulg",
        formData,
        "_I_F1xpz8yPQBXZg0",
      )
      .then(() => {
        Swal.fire("Success", "Your message has been sent.", "success");
        setFormData({
          name: "",
          email: "",
          mobile: "",
          option: "",
          concern: "",
        });
      })
      .catch(() => {
        Swal.fire(
          "Error",
          "Something went wrong. Please try again later.",
          "error",
        );
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Poster />

      <div className="contactus-section">
        <div className="left-contact">
          <img src="form.webp" alt="Contact Us" className="contact-image" />
        </div>
        <div className="right-contact">
          <h4 className="form-heading">Fill the form below</h4>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="input-row">
              <div className="input-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  className="input-field"
                  value={formData.name}
                  onChange={handleChange}
                />
                {formErrors.name && (
                  <p className="error-text">{formErrors.name}</p>
                )}
              </div>
              <div className="input-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="input-field"
                  value={formData.email}
                  onChange={handleChange}
                />
                {formErrors.email && (
                  <p className="error-text">{formErrors.email}</p>
                )}
              </div>
            </div>
            <div className="input-row">
              <div className="input-group">
                <input
                  type="text"
                  name="mobile"
                  placeholder="Mobile"
                  className="input-field"
                  value={formData.mobile}
                  onChange={handleChange}
                />
                {formErrors.mobile && (
                  <p className="error-text">{formErrors.mobile}</p>
                )}
              </div>
              <div className="input-group">
                <select
                  name="option"
                  required
                  className="dropdown-field"
                  value={formData.option}
                  onChange={handleChange}
                >
                  <option value="">Select Flat Options</option>
                  <option value="3 BHK + Servant (2452 Sq.ft.)">
                    3 BHK + Servant (2452 Sq.ft.)
                  </option>
                  <option value="3 BHK + Servant (2165 Sq.ft.)">
                    3 BHK + Servant (2165 Sq.ft.)
                  </option>
                </select>
                {formErrors.option && (
                  <p className="error-text">{formErrors.option}</p>
                )}
              </div>
            </div>
            <div className="input-groupp">
              <textarea
                name="concern"
                placeholder="Your concern"
                className="textarea-field"
                value={formData.concern}
                onChange={handleChange}
              ></textarea>
              {formErrors.concern && (
                <p className="error-text">{formErrors.concern}</p>
              )}
            </div>
            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Submit"}
            </button>
          </form>
        </div>
      </div>

      <Location />
    </>
  );
};

export default Contactus;
